module.exports = __webpack_public_path__ + "static/media/tablet.5c92e19c.svg";